import React from 'react'
import {connect} from 'react-redux'
import {change as changeFieldValue} from 'redux-form';
import qs from 'qs';
import {withRouter} from 'react-router-dom';
import Titulo from '../comum/Titulo';
import {alterouPagina} from '../../util/filtros';
import {
  getAdminEmpresa,
  getGestorEmpresa,
  getOperadorEmpresa,
  getGestorOperacoes,
  getMotoristaEmpresa,
  getFiscalEmbarque,
  PERFIL_ADMIN
} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import {alterouEmpresa} from '../../actions/empresa/alterarEmpresaSelecionada';
import buscarMapaVeiculoItinerarioBloqueioPoltrona
  from '../../actions/itinerario/buscarMapaVeiculoItinerarioBloqueioPoltrona';
import MapaVeiculoItinerario from '../viagem/MapaVeiculoItinerario';
import buscarItinerario from '../../actions/itinerario/buscarItinerario';
import bloquearPoltrona from '../../actions/poltrona/bloquearPoltrona';
import desbloquearPoltrona from '../../actions/poltrona/desbloquearPoltrona';
import ModalCadastrarBloqueioPoltrona from './ModalCadastrarBloqueioPoltrona';
import capitalizarTodasPrimeirasLetras from '../../util/capitalizarTodasPrimeirasLetras';
import {buscarReservasItinerario} from '../../actions/reserva/buscarReservasItinerario';
import selecionarMapaVeiculoItinerario from '../../actions/mapa-veiculo/selecionarMapaVeiculoItinerario';
import {showSuccessMsg} from '../../util/messagesUtil';

export class PainelBloqueioPoltrona extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      assento: ''
    }
  }

  desbloquear (id) {
    const parametros = {
      id: id,
      empresaId: this.props.empresaSelecionada.id
    };

    this.props.desbloquearPoltrona(parametros)
      .then(() => {
          showSuccessMsg('Poltrona desbloqueada com sucesso');

          this.props.buscarMapaVeiculoItinerarioBloqueioPoltrona(this.props.empresaSelecionada.id, this.props.itinerarioSelecionado.id);
      })
  }

  componentDidMount () {
    const parametros = qs.parse(this.props.history.location.search, { ignoreQueryPrefix: true });
    if (parametros.itinerario) {
      this.props.buscarMapaVeiculoItinerarioBloqueioPoltrona(this.props.empresaSelecionada.id, parametros.itinerario);
      this.props.buscarItinerario(this.props.empresaSelecionada.id, parametros.itinerario);
      this.props.buscarReservasItinerario(parametros.itinerario, this.props.empresaSelecionada.id);
    } else {
      this.props.history.push('/painel-itinerarios');
    }
  }

  bloquearPoltrona (assento, fileira) {
    this.props.selecionarMapaVeiculoItinerario(assento, fileira)

  }
  assentosSelecionados(){
    let assentosSelicionado = []
    if( this.props.mapaVeiculoItinerario){
      this.props.mapaVeiculoItinerario.forEach( fileira => {
        fileira.assentos.forEach(assento =>{
          if(assento.selecionado){
            assentosSelicionado.push(assento)
          }
        })

      })
    }

    return assentosSelicionado
  }

  exibirBotaoBloqueio () {
    if(this.assentosSelecionados().length > 0){
      return (
        <div className="row">
          <div className="col-md-12">
            <div className="text-right">
              <button data-toggle="modal"
                      data-target="#modalCadastrarBloqueioPoltrona"
                      className="vx-btn-primary">
                BLOQUEAR
              </button>
            </div>
          </div>
        </div>
      )
    }
    return ''

  }

  exibirCorpoListaPassageiros () {
    return this.props.reservas.map(reserva => <tr key={reserva.id}>
      <th scope="row">{reserva.numeroPoltrona}</th>
      <td>{reserva.pedidoId}</td>
      <td>
        <div>{capitalizarTodasPrimeirasLetras(reserva.passageiroDto.nome)}</div>
        {reserva.passageiroDto.criancaDto ? <div><strong>Criança: </strong>{capitalizarTodasPrimeirasLetras(reserva.passageiroDto.criancaDto.nome)}</div> : ''}
      </td>
      <td>{reserva.passageiroDto.telefone ? reserva.passageiroDto.telefone : 'Não informado'}</td>
      <td>{`${reserva.descCidadeOrigem} -> ${reserva.descCidadeDestino}`}</td>
      <td>{reserva.embarque}</td>
      <td>{reserva.passageiroDto.documentoComFoto}</td>
      <td>{reserva.dataHoraEmbarque ? reserva.dataHoraEmbarque : 'Não embarcado'}</td>
      <td>{reserva.dataHoraDesembarque ? reserva.dataHoraDesembarque : 'Não desembarcado'}</td>
    </tr>)
  }

  exibirListaPassageiros () {
    if (this.props.reservas && this.props.reservas.length) {
      return <React.Fragment>
        <div className='table-responsive'>
          <table className="table table-sm table-striped  table-bordered text-center page-break mt-4" style={{ backgroundColor: '#FFF' }}>
            <thead>
            <tr>
              <td colSpan={9}>
                <strong>Lista de Passageiros</strong>
              </td>
            </tr>
            <tr>
              <th scope="col">Poltrona</th>
              <th scope="col">Pedido</th>
              <th scope="col">Nome</th>
              <th scope='col'>Telefone</th>
              <th scope="col">Trecho</th>
              <th scope="col">Ponto de Embarque</th>
              <th scope="col">Documento</th>
              <th scope="col">Data/Hora embarque</th>
              <th scope="col">Data/Hora desembarque</th>
            </tr>
            </thead>
            <tbody>
            {this.exibirCorpoListaPassageiros()}
            </tbody>
          </table>
        </div>
      </React.Fragment>
    }
    return <div className="vx-gp-empty">Itinerário não possui passagens vendidas</div>
  }

  exibirBloqueios(){
    const bloqueios = [];
    this.props.mapaVeiculoItinerario.forEach(f =>
      f.assentos.forEach(assento => {
        if(assento.poltrona && assento.poltrona.bloqueios.length){
          bloqueios.push(...assento.poltrona.bloqueios);
        }
      }));
    if (bloqueios.length) {
      return  <div className='table-responsive'> <table className="table table-sm table-striped  table-bordered text-center page-break mt-4" style={{ backgroundColor: '#FFF' }}>
      <thead>
        <tr>
          <td colSpan={8}>
            <strong>Poltronas Bloqueadas</strong>
          </td>
        </tr>
        <tr>
          <th scope="col">Poltrona</th>
          <th scope="col">Trecho de Origem</th>
          <th scope='col'>Trecho de Destino</th>
          <th scope='col'>Data</th>
          <th scope='col'>Responsável</th>
          <th scope='col'>Motivo do bloqueio</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        { bloqueios.map(bloqueio =>
          <tr key={`bloqueio-${bloqueio.id}`}>
            <td>
              <span>{bloqueio.numeroPoltrona}</span>
            </td>
            <td>
              <span>{bloqueio.trechoOrigem}</span>
            </td>
            <td>
              <span>{bloqueio.trechoDestino}</span>
            </td>
            <td>
              <span>{bloqueio.dataBloqueio}</span>
            </td>
            <td>
              <span>{bloqueio.usuarioResponsavel}</span>
            </td>
            <td>
              <span>{bloqueio.motivo}</span>
            </td>
            <td>
              <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getGestorOperacoes(this.props.empresaSelecionada.id),
                getAdminEmpresa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id)]}>
                <button type="button" className="btn btn-excluir"
                        data-toggle="modal"
                        data-target="#modalConfirmacaoExclusaoItinerario"
                        title='Excluir'
                        onClick={() => this.desbloquear(bloqueio.id)}>
                  <i className="material-icons nav-icon">&#xe872;</i>
                </button>
              </Autorizacao>
            </td>
          </tr>)}
        </tbody>
      </table></div>
    }
  }

  componentDidUpdate (prevProps) {
    if (alterouEmpresa(this.props, prevProps) || alterouPagina(this.props, prevProps)) {
      this.props.buscarVeiculos(this.props.empresaSelecionada.id, this.props.paginaAtual, this.props.registrosPorPagina);
    }
  }

  render () {
    return (//teste
      <Autorizacao
            perfisPermitidos={[
                PERFIL_ADMIN,
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getGestorOperacoes(this.props.empresaSelecionada.id),
                getAdminEmpresa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id),
                getMotoristaEmpresa(this.props.empresaSelecionada.id),
                getFiscalEmbarque(this.props.empresaSelecionada.id)
            ]}
            empresaSelecionada={this.props.empresaSelecionada}
        >
        <div className="container-padrao">
          <Titulo texto="Bloqueio de poltronas" urlRetorno="/painel-itinerarios"/>
          <MapaVeiculoItinerario mapaVeiculo={this.props.mapaVeiculoItinerario}
                                 selecionar={this.bloquearPoltrona.bind(this)}
                                 trecho={`${this.props.itinerarioSelecionado.rotaDto.cidadeOrigem.nomeComUf} -> ${this.props.itinerarioSelecionado.rotaDto.cidadeDestino.nomeComUf}`}
                                 data={this.props.itinerarioSelecionado.dataHoraPartida}
                                 bloqueio/>
          {this.exibirBotaoBloqueio()}
          {this.exibirBloqueios()}
          {this.exibirListaPassageiros()}
        </div>
        <ModalCadastrarBloqueioPoltrona/>
      </Autorizacao>
    )
  }
}


export const mapStateToProps = state => (
  {
    mapaVeiculoItinerario: state.mapaVeiculoItinerario,
    empresaSelecionada: state.empresaSelecionada,
    itinerarioSelecionado: state.itinerarioSelecionado,
    changeFieldValue,
    reservas: state.reservas
  });


export default withRouter(connect(mapStateToProps, {
  buscarMapaVeiculoItinerarioBloqueioPoltrona,
  bloquearDesbloquearPoltrona: bloquearPoltrona,
  buscarItinerario,
  desbloquearPoltrona,
  buscarReservasItinerario,
  selecionarMapaVeiculoItinerario
})(PainelBloqueioPoltrona))
